<template>
  <div class="FittSystem">
    <div class="page_img">
      <img src="@/assets/img/fill_system.jpg" alt="">
    </div>
    <div class="page_content flex_row content">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="font_shadow page_summary">无人值守AI验配系统</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/fill_main.png" alt="">
      <div class="main_explain fill_explain">全智能化远程验光以及智能化角塑验配，AI选片实现精准定位，完美配适状态</div>
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column system_title">
        <div class="sys_summary">远程验光配镜业务模型</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="sys_back"><img src="@/assets/img/fill_back.png" alt=""></div>
      <div class="sys_main">
        <img class="img1" src="@/assets/img/mode_main.png" alt="">
      </div>
      <div class="sys_main"  style="display: none">
        <img src="@/assets/img/fill_main2.png" alt="">
      </div>
    </div>
    <div style="display: none" class="container_title">
      专家远程会诊
    </div>
    <div style="display: none" class="container flex_row">
      <div class="container_item flex_row" v-for="item in containList">
        <img :src="item.img" alt="">
        <span>{{item.title}}</span>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'FittSystem',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
      containList: []
    }
  },
  created() {
    let containList = [
      {
        img: 'https://ow.visumall.com/public/img/fill_small1.png',
        title: '多方视频会诊'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small2.png',
        title: '手机远程操控'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small3.png',
        title: '眼科检查设备'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small4.png',
        title: '数据自动集成'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small5.png',
        title: '医患同屏诊疗'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small6.png',
        title: '实景现场同步'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small7.png',
        title: '实时病历调取'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small8.png',
        title: 'AI辅助诊断'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small9.png',
        title: '在线专家处方'
      },
      {
        img: 'https://ow.visumall.com/public/img/fill_small10.png',
        title: '技能绩效管理'
      },

    ];
    this.containList = containList;
  },
}
</script>

<style scoped lang="scss">
.FittSystem {
  .content {
    margin: 0.4rem 0 1.5rem;
  }
  .main {
    width: 100%;
    margin-bottom: 1rem;
    img {
      width: 50%;
    }
    .fill_explain {
      margin-top: 1rem;
      font-weight: 500;
      width: 65%;
      padding: 0.25rem 0.45rem;
      font-size: 0.19rem;
    }
  }
  .system {
    margin-bottom: 1rem;
    .system_title {
      margin-bottom: 0.5rem;
      .sys_summary {
        font-size: 0.3rem;
        text-align: center;
        font-weight: bold;
      }
    }
    .sys_back {
      position: relative;
      width: 100%;
      opacity: 0.15;
      img {
        position: absolute;
        width: 100%;
        left: 50%;
        transform: translate(-50%,-5%);
        z-index: -1;
      }
    }
    .sys_main {
      img {
        width: 55%;
      }
      .img1 {
        width: 70%;
      }
    }
  }
  .container_title {
    margin-bottom: 0.32rem;
    font-size: 0.25rem;
    color: #005AFF;
    text-align: center;
  }
  .container {
    flex-wrap: wrap;
    margin-bottom: 1.1rem;
    .container_item {
      width: 20%;
      flex-direction: column;
      margin-bottom: 0.57rem;
      img {
        width: 81%;
      }
      span {
        margin-top: 0.13rem;
        font-size: 0.22rem;
      }
    }
  }
}
</style>
